import { catalogContainer } from 'src/models'
import { getWebAvailableChannel } from 'src/utils'

/**
 * Check if a SKU should be disabled in POAdmin based on critical statuses
 * Only checks: discontinued, stopped, and inactive
 * @param {Object} sku - The SKU object to check
 * @returns {boolean} - True if SKU should be disabled, false otherwise
 */
export const isSkuDisabledForSelection = (sku) => {
  if (!sku) return true

  const normalizeString = str =>
    String(str || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .trim()

  // Check product status
  const productStatus = normalizeString(
    sku?.properties?.productStatus || sku?.properties?.status || ''
  )

  // Critical statuses that should disable the checkbox
  const disabledStatuses = ['discontinued', 'stopped', 'inactive']

  if (disabledStatuses.includes(productStatus)) {
    return true
  }

  return false
}

export const shouldRedirectBasedOnProduct = productData => {
  const skuCount = productData?.sku?.length || 0
  const isBundle = productData?.type === 'bundle'
  const isKit = productData?.type === 'kit'

  const availableChannelsStr =
    productData?.sku?.[0]?.properties?.availableChannels || ''

  const kitAvailableChannel = productData?.properties?.availableChannels || ''

  let hasWeb = false

  if (isBundle && skuCount > 1 && !availableChannelsStr.trim()) {
    hasWeb = true
  } else if (isKit && kitAvailableChannel.trim()) {
    const kitChannels = kitAvailableChannel
      .toLowerCase()
      .split(',')
      .map(c => c.trim())
    hasWeb = !kitChannels.includes(getWebAvailableChannel().toLowerCase())
  } else if (availableChannelsStr.trim()) {
    const availableChannels = availableChannelsStr
      .toLowerCase()
      .split(',')
      .map(c => c.trim())
    hasWeb = !availableChannels.includes(getWebAvailableChannel().toLowerCase())
  }

  return skuCount > 1 || isBundle || hasWeb
}

export const shouldRedirectToPdp = async identifier => {
  if (!identifier) {
    console.warn('No identifier provided')
    return false
  }

  const response = await catalogContainer.getProduct({
    productId: identifier,
    suppressProductEvent: true,
  })

  const productData = response?.product?.[0]

  if (!productData) {
    console.warn('No product data returned for identifier:', identifier)
    return false
  }

  return shouldRedirectBasedOnProduct(productData)
}
